import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '@/store'
import { canViewIndex, canViewEq, canViewUser } from '../utils/permission'
// import superPer from '../core/permissions.yaml'
const rulers = [{
  match: '*',
  except: [
    '/user/login',
    '/exception/403',
    '/exception/404'
  ],
  handler: async function (route, next) {
    canViewIndex()
    if (this.except.includes(route.path)) {
      next(true)
    } else {
      if (store.state.sessionToken) {
        if (route.path === '/') {
          if (process.env.VUE_APP_TYPE_TEST === 'single') {
            next('/grainstore/detail?store=aaaaaaaaaa&type=summary')
          }
          if (canViewIndex()) {
            next(true)
          } else {
            next('/graindepot')
          }
        } else if (route.path === '/equipment') {
          if (canViewEq()) {
            next(true)
          } else {
            next('/graindepot')
          }
        } else if (route.path === '/users') {
          if (canViewUser()) {
            next(true)
          } else {
            next('/graindepot')
          }
        } else {
          next(true)
        }
      } else {
        next('/user/login')
      }
    }
  },
  fallbackUrl: '/exception/403'
}]

VueTk.tkRouterAuth.init(rulers, router)
